export default __webpack_public_path__ + "static/media/img-0426-belarus-premium-face.417eb470.png";